import Vue from 'vue'
import BookingEngine from '@alpitour/components/blocks/booking-engine/booking-engine.vue'
import Pad from '@alpitour/components/blocks/pad.vue'
import SentryInit from '@src/sentry'
import BookingMixins from "@booking/utilities/mixins"
import AlpitourMixins from "@alpitour/utilities/mixins"

// site specific components and settings
export default function site_config() {
  Vue.component('booking-engine', BookingEngine)
  Vue.component('pad', Pad)
  Vue.mixin(BookingMixins)
  Vue.mixin(AlpitourMixins)
  SentryInit({
    tracePropagationTargets: [
      /^https:\/\/([^.]+\.)?senna\.vadobay\.com/,
      /^https:\/\/([^.]+\.)?api\.vacanze\.vadobay\.com/,
      /^\//,
    ],
  })
}